import { useMediaQuery } from '@material-ui/core';
import classnames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { ROUTES } from '../../../../router/consts';
import { makePath } from '../../../../utils';
import { Container } from '../../../Layout/components/Container';
import { ETextColor } from '../../../Projects/enums';
import { IHomeProject } from '../../store/models';

interface IProps {
    project: IHomeProject;
    index: number;
    totalItems: number;
}

export const SliderItem: React.FC<IProps> = ({ project, index, totalItems }) => {
    const matchesXs = useMediaQuery('(max-width:600px)');
    const [scroll, setScroll] = React.useState(0);

    React.useEffect(
        () => {
            window.addEventListener('scroll', () => setScroll(window.scrollY));
        },
        [],
    );

    return (
        <Link to={makePath<{ slug: string }>(ROUTES.PROJECT, { slug: project.slug })}>
            <div
                key={project.id}
                className={classnames(
                    'main-page_carousel-img',
                    { 'main-page_carousel-img__white': project.slider_text_color === ETextColor.WHITE },
                )}
            >
                <img
                    src={matchesXs ? project.mobile_photo : project.photo}
                    style={{
                        transform: `translateY(${scroll * 0.05}%)`
                    }}
                    alt=""
                />
                <div className="main-page_carousel-details">
                    <Container>
                        <div>
                            <span className="main-page_carousel-details_index">
                                {index + 1} / {totalItems}
                            </span>
                            <h4 className="main-page_carousel-details_name">{project.name}</h4>
                            <h5 className="main-page_carousel-details_category">{project.category.name}</h5>
                        </div>
                    </Container>
                </div>
            </div>
        </Link>
    );
};
